import { ModalComponent } from '@operations/shared';
import { ConfirmRewardsContent } from './ConfirmRewardsContent';
import { IAddRewardsFormValues } from '../../../utils/commonInterfaces';
interface ConfirmRewardsModalProps {
    visible: boolean;
    loading: boolean;
    pendingValues: IAddRewardsFormValues | null;
    userInfo: any;
    rewardsAmountDisplay: string;
    onConfirm: () => void;
    onClose: () => void;
}

export const ConfirmRewardsModal = ({
    visible,
    loading,
    pendingValues,
    userInfo,
    rewardsAmountDisplay,
    onConfirm,
    onClose,
}: ConfirmRewardsModalProps) => (
    <ModalComponent
        visibleModal={visible}
        handleAcceptModal={onConfirm}
        handleCloseModal={onClose}
        loadingConfirm={loading}
        cancelDisable={loading}
        maskClosable={!loading}
        closable={!loading}
        keyboard={!loading}
        okText="Yes, Add Rewards"
        cancelText="No, Cancel"
        title=" "
        width={520}
        content={
            pendingValues ? (
                <ConfirmRewardsContent
                    pendingValues={pendingValues}
                    userInfo={userInfo}
                    rewardsAmountDisplay={rewardsAmountDisplay}
                />
            ) : null
        }
    />
);
